import { render } from "./FutureStemStarsView.vue?vue&type=template&id=ef637440&scoped=true"
const script = {}

import "./FutureStemStarsView.vue?vue&type=style&index=0&id=ef637440&scoped=true&lang=css"

import exportComponent from "/home/runner/work/nexascale/nexascale/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef637440"]])

export default __exports__